import React from "react";
import { Breadcrumb } from "../../../../atoms/breadcrumb";
import {
    useMyApprovedListQuery,
} from "../../../../../store/requestManagement/requestSlice";
import { formattedDateTime } from "../../../../../utils";
import { Skeleton } from "../../../../atoms/skeleton";
import { Input } from "../../../../atoms/input";
import { usePaginationHook } from "../../../../molecules/pagination/usePaginationHook";
import { Pagination } from "../../../../molecules/pagination";
import { Dropdown } from "../../../../atoms/dropdown";
import { PAGE_NAME } from "../../../../../constants/constants";
import { Icon } from "../../../../atoms/icon";
import { Modal } from "../../../../molecules/modal";
import { Comments } from "../../../../organisms/requestManagement/comments";

const MyApprovedList = () => {
    const pageClassName = "p-myApprovedList";

    const [isOpenComment, setIsOpenComment] = React.useState(false);
    const [comments, setComments] = React.useState<any[]>([]);
    const [requestId, setRequestId] = React.useState("");
    const [search, setSearch] = React.useState("");
    const [query, setQuery] = React.useState({
        current: 1,
        limit: 20,
        search: "",
        duration: 0,
        toolNames: [] as string[],
    });

    const { data, isLoading } = useMyApprovedListQuery({
        search: search,
        limit: query.limit,
        current_page: query.current,
    });

    const pageChangeHandler = (page: number) => {
        setQuery({ ...query, current: page });
    };

    const limitChangeHandler = (limit: number) => {
        setQuery({ ...query, limit: limit });
    };

    const {
        totalData,
        handleFirstPage,
        handlePrevPage,
        handleLastPage,
        handleNextPage,
        renderPageNumbers,
    } = usePaginationHook({
        totalNumberOfData: data?.result?.total,
        perPage: query.limit,
        setCurrentPage: pageChangeHandler,
        currentPage: query.current,
        className: "m-pagination",
    });

    const searchHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearch(e.target.value);
        setQuery({ ...query, current: 1 });
    };


    return (
        <div className={pageClassName}>
            <Breadcrumb />
            <p className={`${pageClassName}__title`}>
                {PAGE_NAME.MY_APPROVED_LIST}
            </p>
            <div className={`${pageClassName}__container`}>
                <div className={`${pageClassName}__header`}>
                    <div className={`${pageClassName}__search`}>
                        <Input
                            placeholder="Search"
                            onChange={(e) => {
                                searchHandler(e);
                                handleFirstPage();
                            }}
                            value={search}
                        />
                    </div>
                </div>
                <div className={`${pageClassName}__container__content`}>
                    {isLoading ? (
                        <div className={`${pageClassName}__skeleton`}>
                            {[1, 2, 3, 4, 5, 6].map((item: any) => (
                                <div className={`${pageClassName}__skeleton__container`}>
                                    <div className={`${pageClassName}__skeleton__data`}>
                                        <div className={`${pageClassName}__skeleton__saas`}>
                                            {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((item: any) => (
                                                <div
                                                    className={`${pageClassName}__skeleton__saas__tool`}
                                                    key={item}
                                                >
                                                    <div
                                                        className={`${pageClassName}__skeleton__saas__logo`}
                                                    >
                                                        <Skeleton height="small" />
                                                    </div>
                                                    <div
                                                        className={`${pageClassName}__skeleton__saas__date`}
                                                    >
                                                        <Skeleton height="small" />
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    ) : data?.result?.data?.length > 0 ? (
                        <div
                            className={`${pageClassName}__container__userRequest ${data?.result?.subType === "Configuration"
                                ? `${pageClassName}__container__userRequest--configuration`
                                : ""
                                }`}
                        >
                            {data?.result?.data?.map((request: any, index: number) => (
                                <div
                                    className={`${pageClassName}__container__userRequest__content`}
                                    key={index}
                                >
                                    <div
                                        className={`${pageClassName}__container__userRequest__content__container`}
                                    >
                                        <div
                                            className={`${pageClassName}__container__userRequest__item`}
                                        >
                                            <p
                                                className={`${pageClassName}__container__userRequest__item__title`}
                                            >
                                                Sub Request ID
                                            </p>
                                            <p
                                                className={`${pageClassName}__container__userRequest__item__value`}
                                            >
                                                {request?.id}
                                            </p>
                                        </div>

                                        <div
                                            className={`${pageClassName}__container__userRequest__item`}
                                        >
                                            <p
                                                className={`${pageClassName}__container__userRequest__item__title`}
                                            >
                                                Type
                                            </p>
                                            <p
                                                className={`${pageClassName}__container__userRequest__item__value`}
                                            >
                                                {request?.request?.type}
                                            </p>
                                        </div>

                                        <div
                                            className={`${pageClassName}__container__userRequest__item`}
                                        >
                                            <p
                                                className={`${pageClassName}__container__userRequest__item__title`}
                                            >
                                                Sub Type
                                            </p>
                                            <p
                                                className={`${pageClassName}__container__userRequest__item__value`}
                                            >
                                                {request?.request?.sub_type}
                                            </p>
                                        </div>

                                        {request?.firstName && request?.lastName && (
                                            <div
                                                className={`${pageClassName}__container__userRequest__item`}
                                            >
                                                <p
                                                    className={`${pageClassName}__container__userRequest__item__title`}
                                                >
                                                    User Name
                                                </p>
                                                <p
                                                    className={`${pageClassName}__container__userRequest__item__value`}
                                                >
                                                    {request?.firstName} {request?.lastName}
                                                </p>
                                            </div>
                                        )}

                                        {request?.firstName && (
                                            <div
                                                className={`${pageClassName}__container__userRequest__item`}
                                            >
                                                <p
                                                    className={`${pageClassName}__container__userRequest__item__title`}
                                                >
                                                    First Name
                                                </p>
                                                <p
                                                    className={`${pageClassName}__container__userRequest__item__value`}
                                                >
                                                    {request?.firstName}
                                                </p>
                                            </div>
                                        )}

                                        {request?.lastName && (
                                            <div
                                                className={`${pageClassName}__container__userRequest__item`}
                                            >
                                                <p
                                                    className={`${pageClassName}__container__userRequest__item__title`}
                                                >
                                                    Last Name
                                                </p>
                                                <p
                                                    className={`${pageClassName}__container__userRequest__item__value`}
                                                >
                                                    {request?.lastName}
                                                </p>
                                            </div>
                                        )}

                                        {request?.designation && (
                                            <div
                                                className={`${pageClassName}__container__userRequest__item`}
                                            >
                                                <p
                                                    className={`${pageClassName}__container__userRequest__item__title`}
                                                >
                                                    Designation
                                                </p>
                                                <p
                                                    className={`${pageClassName}__container__userRequest__item__value`}
                                                >
                                                    {request?.designation}
                                                </p>
                                            </div>
                                        )}

                                        {request?.address && (
                                            <div
                                                className={`${pageClassName}__container__userRequest__item`}
                                            >
                                                <p
                                                    className={`${pageClassName}__container__userRequest__item__title`}
                                                >
                                                    Address
                                                </p>
                                                <p
                                                    className={`${pageClassName}__container__userRequest__item__value`}
                                                >
                                                    {request?.address}
                                                </p>
                                            </div>
                                        )}

                                        {request?.organization && (
                                            <div
                                                className={`${pageClassName}__container__userRequest__item`}
                                            >
                                                <p
                                                    className={`${pageClassName}__container__userRequest__item__title`}
                                                >
                                                    Organization
                                                </p>
                                                <p
                                                    className={`${pageClassName}__container__userRequest__item__value`}
                                                >
                                                    {request?.organization?.name}
                                                </p>
                                            </div>
                                        )}

                                        {request?.department && (
                                            <div
                                                className={`${pageClassName}__container__userRequest__item`}
                                            >
                                                <p
                                                    className={`${pageClassName}__container__userRequest__item__title`}
                                                >
                                                    Department
                                                </p>
                                                <p
                                                    className={`${pageClassName}__container__userRequest__item__value`}
                                                >
                                                    {request?.department}
                                                </p>
                                            </div>
                                        )}

                                        {request?.section && (
                                            <div
                                                className={`${pageClassName}__container__userRequest__item`}
                                            >
                                                <p
                                                    className={`${pageClassName}__container__userRequest__item__title`}
                                                >
                                                    Section
                                                </p>
                                                <p
                                                    className={`${pageClassName}__container__userRequest__item__value`}
                                                >
                                                    {request?.section}
                                                </p>
                                            </div>
                                        )}

                                        {request?.projects?.length > 0 && (
                                            <div
                                                className={`${pageClassName}__container__userRequest__item`}
                                            >
                                                <p
                                                    className={`${pageClassName}__container__userRequest__item__title`}
                                                >
                                                    Projects
                                                </p>
                                                <div
                                                    className={`${pageClassName}__container__userRequest__item__list`}
                                                >
                                                    {request?.projects.map((project: any, index: number) => (
                                                        <li key={index}>{project}</li>
                                                    ))}
                                                </div>
                                            </div>
                                        )}

                                        {request?.manager && (
                                            <div
                                                className={`${pageClassName}__container__userRequest__item`}
                                            >
                                                <p
                                                    className={`${pageClassName}__container__userRequest__item__title`}
                                                >
                                                    PIC/Manager
                                                </p>
                                                <p
                                                    className={`${pageClassName}__container__userRequest__item__value`}
                                                >
                                                    {request?.manager?.middleName
                                                        ? `${request?.manager?.firstName} ${request?.manager?.middleName} ${request?.manager?.lastName} (${request?.manager?.email})`
                                                        : `${request?.manager?.firstName} ${request?.manager?.lastName} (${request?.manager?.email})`}
                                                </p>
                                            </div>
                                        )}

                                        {request?.email && (
                                            <div
                                                className={`${pageClassName}__container__userRequest__item`}
                                            >
                                                <p
                                                    className={`${pageClassName}__container__userRequest__item__title`}
                                                >
                                                    Email
                                                </p>
                                                <p
                                                    className={`${pageClassName}__container__userRequest__item__value`}
                                                >
                                                    {request?.email}
                                                </p>
                                            </div>
                                        )}

                                        <div
                                            className={`${pageClassName}__container__userRequest__item`}
                                        >
                                            <p
                                                className={`${pageClassName}__container__userRequest__item__title`}
                                            >
                                                SaaS Tool
                                            </p>
                                            <p
                                                className={`${pageClassName}__container__userRequest__item__value`}
                                            >
                                                {request?.saasTool}
                                            </p>
                                        </div>

                                        {request?.type && (
                                            <div
                                                className={`${pageClassName}__container__userRequest__item`}
                                            >
                                                <p
                                                    className={`${pageClassName}__container__userRequest__item__title`}
                                                >
                                                    Type
                                                </p>
                                                <p
                                                    className={`${pageClassName}__container__userRequest__item__value`}
                                                >
                                                    {request?.type}
                                                </p>
                                            </div>
                                        )}

                                        {request?.type && request?.name && (
                                            <div
                                                className={`${pageClassName}__container__userRequest__item`}
                                            >
                                                <p
                                                    className={`${pageClassName}__container__userRequest__item__title`}
                                                >
                                                    {request?.type} Name
                                                </p>
                                                <p
                                                    className={`${pageClassName}__container__userRequest__item__value`}
                                                >
                                                    {request?.name}
                                                </p>
                                            </div>
                                        )}

                                        {request?.type && request?.newName && (
                                            <div
                                                className={`${pageClassName}__container__userRequest__item`}
                                            >
                                                <p
                                                    className={`${pageClassName}__container__userRequest__item__title`}
                                                >
                                                    {request?.type} New Name
                                                </p>
                                                <p
                                                    className={`${pageClassName}__container__userRequest__item__value`}
                                                >
                                                    {request?.newName}
                                                </p>
                                            </div>
                                        )}

                                        {request?.role && (
                                            <div
                                                className={`${pageClassName}__container__userRequest__item`}
                                            >
                                                <p
                                                    className={`${pageClassName}__container__userRequest__item__title`}
                                                >
                                                    Role
                                                </p>
                                                <p
                                                    className={`${pageClassName}__container__userRequest__item__value`}
                                                >
                                                    {request?.role}
                                                </p>
                                            </div>
                                        )}

                                        {request?.templateType && (
                                            <div
                                                className={`${pageClassName}__container__userRequest__item`}
                                            >
                                                <p
                                                    className={`${pageClassName}__container__userRequest__item__title`}
                                                >
                                                    Template Type
                                                </p>
                                                <p
                                                    className={`${pageClassName}__container__userRequest__item__value`}
                                                >
                                                    {request?.templateType}
                                                </p>
                                            </div>
                                        )}


                                        {request?.approvers?.length > 0 && (
                                            <div
                                                className={`${pageClassName}__container__userRequest__item`}
                                            >
                                                <p
                                                    className={`${pageClassName}__container__userRequest__item__title`}
                                                >
                                                    Approvers
                                                </p>
                                                <div
                                                    className={`${pageClassName}__container__userRequest__item__value`}
                                                >
                                                    {request?.approvers.map(
                                                        (approver: any, index: number) => (
                                                            <p key={index}>
                                                                {approver?.middleName
                                                                    ? `${approver?.firstName} ${approver?.middleName} ${approver?.lastName}`
                                                                    : `${approver?.firstName} ${approver?.lastName}`}
                                                            </p>
                                                        )
                                                    )}
                                                </div>
                                            </div>
                                        )}

                                        <div
                                            className={`${pageClassName}__container__userRequest__item`}
                                        >
                                            <p
                                                className={`${pageClassName}__container__userRequest__item__title`}
                                            >
                                                Status
                                            </p>
                                            <p
                                                className={`${pageClassName}__container__userRequest__item__status`}
                                            >
                                                {request?.status}
                                            </p>
                                        </div>

                                        {request?.reviewedBy && (
                                            <div
                                                className={`${pageClassName}__container__userRequest__item`}
                                            >
                                                <p
                                                    className={`${pageClassName}__container__userRequest__item__title`}
                                                >
                                                    Reviewed By
                                                </p>
                                                <p
                                                    className={`${pageClassName}__container__userRequest__item__value`}
                                                >
                                                    {request?.reviewedBy?.middleName
                                                        ? `${request?.reviewedBy?.firstName} ${request?.reviewedBy?.middleName} ${request?.reviewedBy?.lastName}`
                                                        : `${request?.reviewedBy?.firstName} ${request?.reviewedBy?.lastName}`}
                                                </p>
                                            </div>
                                        )}

<div
                                            className={`${pageClassName}__container__userRequest__item`}
                                        >
                                            <p
                                                className={`${pageClassName}__container__userRequest__item__title`}
                                            >
                                                Reviewed Time
                                            </p>
                                            <p
                                                className={`${pageClassName}__container__userRequest__item__value`}
                                            >
                                                {formattedDateTime(request?.reviewedAt)}
                                            </p>
                                        </div>

                                        <div
                                            className={`${pageClassName}__container__userRequest__item`}
                                        >
                                            <p
                                                className={`${pageClassName}__container__userRequest__item__title`}
                                            >
                                                Created Time
                                            </p>
                                            <p
                                                className={`${pageClassName}__container__userRequest__item__value`}
                                            >
                                                {formattedDateTime(request?.request?.created_at)}
                                            </p>
                                        </div>

                                        {request?.issueSummary && (
                                            <div
                                                className={`${pageClassName}__container__userRequest__item`}
                                            >
                                                <p
                                                    className={`${pageClassName}__container__userRequest__item__title`}
                                                >
                                                    Issue Summary
                                                </p>
                                                <p
                                                    className={`${pageClassName}__container__userRequest__item__value`}
                                                >
                                                    {request?.issueSummary}
                                                </p>
                                            </div>
                                        )}

                                        {request?.instruction && (
                                            <div
                                                className={`${pageClassName}__container__userRequest__item`}
                                            >
                                                <p
                                                    className={`${pageClassName}__container__userRequest__item__title`}
                                                >
                                                    Issue Description
                                                </p>
                                                <p
                                                    style={{
                                                        whiteSpace: 'pre-line',
                                                        overflowWrap: 'break-word',
                                                        wordWrap: 'break-word',
                                                        wordBreak: 'break-all'
                                                    }}
                                                    className={`${pageClassName}__container__userRequest__item__value`}
                                                    dangerouslySetInnerHTML={{
                                                        __html: request?.instruction,
                                                    }}
                                                />
                                            </div>
                                        )}

                                        {request?.files && (
                                            <div
                                                className={`${pageClassName}__container__userRequest__item`}
                                            >
                                                <p
                                                    className={`${pageClassName}__container__userRequest__item__title`}
                                                >
                                                    Attachments
                                                </p>
                                                <div
                                                    className={`${pageClassName}__container__userRequest__item__files`}
                                                >
                                                    {request?.files.map((file: any, index: number) => (
                                                        <a
                                                            href={file.basePath + "/" + file?.filePath}
                                                            target="_blank"
                                                            rel="noreferrer"
                                                            key={index}
                                                            className={`${pageClassName}__container__userRequest__item__files__file`}
                                                        >
                                                            {file?.fileName}
                                                        </a>
                                                    ))}
                                                </div>
                                            </div>
                                        )}

                                        <div
                                            className={`${pageClassName}__container__userRequest__item`}
                                        >
                                            <p
                                                className={`${pageClassName}__container__userRequest__item__title`}
                                            >
                                                Comments
                                            </p>
                                            <div
                                                className={`${pageClassName}__container__userRequest__item__commentsContainer`}
                                            >
                                                <button
                                                    className={`${pageClassName}__container__userRequest__item__comments`}
                                                    onClick={() => {
                                                        setIsOpenComment(true);
                                                        setComments(request?.comments);
                                                        setRequestId(request?.id);
                                                    }}
                                                >
                                                    {request?.comments?.length}
                                                </button>
                                                {/* <button
                                                    className={`${pageClassName}__container__userRequest__item__details`}
                                                    onClick={() => navigate(`/comments/${request?.id}`)}
                                                >
                                                    Details
                                                </button> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div className={`${pageClassName}__noData`}>
                            <p>No data found</p>
                            <Icon icon="sadFace" size="tertiary" />
                        </div>
                    )}
                </div>

                <div className={`${pageClassName}__pagination`}>
                    <div className={`${pageClassName}__pagination__limit`}>
                        <p>Display</p>
                        <div className={`${pageClassName}__pagination__dropdown`}>
                            <Dropdown
                                options={[
                                    { label: "20", value: 20 },
                                    { label: "50", value: 50 },
                                    { label: "100", value: 100 },
                                ]}
                                selected={{ label: query.limit, value: query.limit }}
                                onClickChange={(e) => {
                                    limitChangeHandler(e.value as number);
                                    handleFirstPage();
                                }}
                                isBordered
                                isIcon

                            />
                        </div>
                    </div>
                    <div className={`${pageClassName}__pagination__number`}>
                        {data?.result?.total ? (
                            <p>
                                Show {data?.result?.from} -{" "}
                                {data?.result?.from + query.limit - 1 < data?.result?.total
                                    ? data?.result?.from + query.limit - 1
                                    : data?.result?.total}{" "}
                                of {data?.result?.total}
                            </p>
                        ) : (
                            <p>Show 00 - 00 of 00</p>
                        )}
                    </div>

                    <div className={`${pageClassName}__pagination__nav`}>
                        {data?.result?.total > query.limit && (
                            <Pagination
                                totalData={totalData}
                                page={query.current}
                                handleFirstPage={handleFirstPage}
                                handlePrevPage={handlePrevPage}
                                handleLastPage={handleLastPage}
                                handleNextPage={handleNextPage}
                                renderPageNumbers={renderPageNumbers}
                            />
                        )}
                    </div>
                </div>
            </div>

            <Modal
                isOpen={isOpenComment}
                onClose={() => setIsOpenComment(false)}
                header="Comments"
            >
                <Comments
                    comments={comments}
                    setComments={setComments}
                    requestId={requestId}
                />
            </Modal>
        </div>
    );
};

export default MyApprovedList;
